/**
 * Fase 2, W24 (K9): sugestão do próximo código de um plano hierárquico (categorias do Financeiro: 1, 1.1, 3.1.02). Mesma
 * função no servidor (`GET /financeiro/categorias/sugerir-codigo`) e na tela (preenche o campo ao criar), então os dois
 * nunca discordam.
 *
 * Regras:
 * - irmãos são os códigos que começam pelo código do pai mais um ponto e têm exatamente um nível a mais (na raiz, os
 *   códigos sem ponto);
 * - o último nível numérico dos irmãos dá o próximo (maior + 1), com a largura do maior irmão (3.1.01, 3.1.02 ... 3.1.10);
 * - sem irmãos, começa em 1 na raiz e no segundo nível (3.1) e em 01 do terceiro nível em diante (3.1.01), o formato do
 *   plano de contas do sistema antigo;
 * - código já usado (em qualquer lugar) é pulado; pai sem código não tem sugestão (null).
 */
export function sugerirCodigoHierarquico(codigoPai: string | null | undefined, codigos: readonly (string | null | undefined)[]): string | null {
  const pai = codigoPai?.trim() ?? '';
  const temPai = codigoPai !== undefined && codigoPai !== null;
  if (temPai && !pai) return null;
  const usados = new Set(codigos.filter((c): c is string => !!c).map((c) => c.trim()));
  const prefixo = pai ? `${pai}.` : '';
  const nivel = pai ? pai.split('.').length + 1 : 1;
  let maior = 0;
  let largura = 0;
  for (const c of usados) {
    if (pai ? !c.startsWith(prefixo) : c.includes('.')) continue;
    const resto = pai ? c.slice(prefixo.length) : c;
    if (!/^\d{1,6}$/.test(resto)) continue;
    maior = Math.max(maior, Number(resto));
    largura = Math.max(largura, resto.length);
  }
  if (!largura) largura = nivel >= 3 ? 2 : 1;
  for (let n = maior + 1; n < maior + 1000; n++) {
    const candidato = `${prefixo}${String(n).padStart(largura, '0')}`;
    if (!usados.has(candidato)) return candidato;
  }
  return null;
}
